import React, { lazy } from 'react';
import { MapPin, Phone, ExternalLink } from 'lucide-react';
const ADDRESS = '24786 Crestview, Farmington Hills, MI 48335';
const MAP_EMBED_SRC = 'https://www.google.com/maps?q=24786+Crestview,+Farmington+Hills,+MI+48335&output=embed';
const MAP_OPEN_URL = 'https://www.google.com/maps/search/?api=1&query=Storm+Sport+Taekwondo+24786+Crestview+Farmington+Hills+MI+48335';
export function LocationBlock() {
  return <div className="bg-paper rounded-2xl shadow-soft border border-subtle-gray overflow-hidden flex flex-col lg:flex-row" data-id="element-371">
      {/* Info Side */}
      <div className="p-8 lg:p-12 lg:w-1/2 flex flex-col justify-center" data-id="element-372">
        <h3 className="text-3xl text-ink mb-8" data-id="element-373">Storm Taekwondo</h3>

        <div className="flex flex-col gap-6 mb-8" data-id="element-374">
          <div className="flex items-start gap-4" data-id="element-375">
            <div className="w-12 h-12 bg-off-white rounded-xl flex items-center justify-center shrink-0 text-storm-red" data-id="element-376">
              <MapPin className="w-6 h-6" data-id="element-377" />
            </div>
            <div data-id="element-378">
              <p className="font-bold text-ink text-lg" data-id="element-379">Location</p>
              <p className="text-gray-warm" data-id="element-380">
                24786 Crestview
                <br data-id="element-381" />
                Farmington Hills, MI 48335
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-382">
            <div className="w-12 h-12 bg-off-white rounded-xl flex items-center justify-center shrink-0 text-storm-red" data-id="element-383">
              <Phone className="w-6 h-6" data-id="element-384" />
            </div>
            <div data-id="element-385">
              <p className="font-bold text-ink text-lg" data-id="element-386">Phone</p>
              <a href="tel:517-220-0621" className="text-gray-warm hover:text-storm-red transition-colors" data-id="element-387">
                517-220-0621
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-subtle-gray" data-id="element-388">
          <p className="font-bold text-ink mb-2" data-id="element-389">Serving Nearby Communities:</p>
          <p className="text-gray-warm text-sm leading-relaxed" data-id="element-390">
            Farmington Hills, Novi, Commerce, Walled Lake, Wixom, Livonia,
            Farmington, Waterford, Northville and nearby Southeast Michigan
            areas.
          </p>
        </div>
      </div>

      {/* Real Google Maps Embed */}
      <div className="lg:w-1/2 h-80 lg:h-auto relative bg-ink" data-id="element-391">
        <iframe title="Storm Sport Taekwondo on Google Maps" src={MAP_EMBED_SRC} width="100%" height="100%" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen className="absolute inset-0 w-full h-full border-0" data-id="element-392" />
        <a href={MAP_OPEN_URL} target="_blank" rel="noopener noreferrer" aria-label={`Open ${ADDRESS} in Google Maps`} className="absolute top-4 left-4 inline-flex items-center gap-1.5 bg-storm-red hover:bg-storm-red-dark text-white text-xs font-bold uppercase tracking-wide px-3 py-2 rounded-full shadow-lg transition-colors z-10" data-id="element-393">
          Open in Maps
          <ExternalLink className="w-3.5 h-3.5" data-id="element-394" />
        </a>
      </div>
    </div>;
}